
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next-battle",
      function () {
        return require("private-next-pages/next-battle.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/next-battle"])
      });
    }
  